module.exports = __webpack_public_path__ + "static/media/fordate-bg.fec3587a.svg";